import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgChatDisabledUrl from '@/assets/misc/img_chat-disabled.svg'
import ChatDisabledIllustration from '@/components/SpotIllustration/ChatDisabledIllustration'

export interface JobNotSupportedProps {
  onBackToCallCenter: () => unknown
}

export function JobNotSupported({ onBackToCallCenter }: JobNotSupportedProps) {
  return (
    <EmptyState pad grow>
      <EmptyStateIllustration
        src={imgChatDisabledUrl}
        illustration={byDesign(undefined, ChatDisabledIllustration)}
      />
      <EmptyStateTitle>Not Supported</EmptyStateTitle>
      <EmptyStateDescription>This job is not supported</EmptyStateDescription>
      <EmptyStateActions>
        <Button
          label="Back to Call Center"
          variant="primary"
          onPress={() => onBackToCallCenter()}
        />
      </EmptyStateActions>
    </EmptyState>
  )
}
